
export class WebGLContextBuilder {

    public build(gl: WebGLRenderingContext): WebGLRenderingContext {
        try {

            gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
            gl.enable(gl.BLEND);

            gl.enable(gl.CULL_FACE);
            gl.cullFace(gl.BACK);

            gl.clearColor(0.0, 0.0, 0.0, 1.0);
            gl.enable(gl.DEPTH_TEST);

            let textureFloatExt = gl.getExtension('OES_texture_float');

            if(!textureFloatExt) {
                throw new Error('Required extension OES_texture_float not supported');
            }

            return gl;

        } catch (e) {
            console.error(e);
        }

        throw new Error("Could not initialize WebGL, the browser probably doesn't support it");
    }

}